import {DraftError} from './DraftError.js'

export class GetFreeAdsAvailableAdPublisherError extends DraftError {}
